export const moveToValues = [
    'application_pending',
    'approval_pending',
    'approved',
    'basic_registration',
    'confirmation_completed',
    'confirmed',
    'created',
    'declined',
    'email_unconfirmed',
    'end',
    'init',
    'invited',
    'localcommunity_selection',
    'phone_number',
    'photo',
    'interest',
    'splashpage',
    'creator_offer',
    'profile_completion',
    // TODO: Remove this after INPOKEMON-4465
    'photo_submitted',
    'interests_submitted',
    'registered',
    'event_wall',
] as const

export type TWorkflowMoveTo = (typeof moveToValues)[number]
